import { render } from "./BoardSimpleRank2.vue?vue&type=template&id=bde7f10e&scoped=true"
import script from "./BoardSimpleRank2.vue?vue&type=script&lang=js"
export * from "./BoardSimpleRank2.vue?vue&type=script&lang=js"

import "./BoardSimpleRank2.vue?vue&type=style&index=0&id=bde7f10e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde7f10e"],['__file',"src/components/h5/board/BoardSimpleRank2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bde7f10e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bde7f10e', __exports__)) {
    api.reload('bde7f10e', __exports__)
  }
  
  module.hot.accept("./BoardSimpleRank2.vue?vue&type=template&id=bde7f10e&scoped=true", () => {
    api.rerender('bde7f10e', render)
  })

}


export default __exports__